import React, { useEffect, useState } from 'react';

import { Dashboard, Summary } from '|/app/services';
import MobileNavigationRail from './components/mobile-navigation-rail';
import NavigationRail from './components/navigation-rail';

interface ResponsiveNavigationRailProps {
  dashboard: Dashboard | null;
  summary: Summary | null;
  onNavigate?: () => void;
}

const ResponsiveNavigationRail: React.FC<ResponsiveNavigationRailProps> = ({
  dashboard = null,
  summary = null,
  onNavigate = () => undefined
}) => {
  const [isMobile, setIsMobile] = useState(window.innerWidth < 1024);

  useEffect(() => {
    const checkIfMobile = () => {
      setIsMobile(window.innerWidth < 1024);
    };

    window.addEventListener('resize', checkIfMobile);

    return () => {
      window.removeEventListener('resize', checkIfMobile);
    };
  }, []);

  if (isMobile) {
    return <MobileNavigationRail dashboard={dashboard} summary={summary} />;
  }

  return <NavigationRail dashboard={dashboard} summary={summary} onNavigate={onNavigate} />;
};

export default ResponsiveNavigationRail;
